// Container for each page
import styles from "./PageLayout.module.scss";

const PageLayout: React.FC = ({ children }) => {
  return <div className={styles["container"]}>{children}</div>;
};

export default PageLayout;
